<footer class="footer">
	<div class="link-block">
		<a href="https://ibescore.com">
			<span>IBEScore</span>
		</a>
	</div>
</footer>
